// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { PicturesPage, TradesPage, RemdataPage, CommunicationsPage, UnsentCasesPage } from "./"

export default {
  path: "case/",
  name: "Damage case",
  childRoutes: [
    { path: ":caseId/pictures", name: "Pictures page", component: PicturesPage, isIndex: true },
    { path: ":caseId/trades", name: "Trades page", component: TradesPage },
    { path: ":caseId/remdata", name: "Remdata page", component: RemdataPage },
    { path: ":caseId/communications", name: "Communications page", component: CommunicationsPage },
    { path: "unsent", name: "Unsent cases page", component: UnsentCasesPage },
  ],
}



// WEBPACK FOOTER //
// ./src/features/damage-case/route.js